import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { EnvConfigField } from './EnvConfigField';
import type { EnvConfigEntry } from './EnvConfigField';

export type { EnvConfigEntry };

export const EnvConfigFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'EnvConfigField',
    component: EnvConfigField,
  }),
);
